<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import axios from '../axios';
import store from "../store";

const route = useRoute();
const errors = ref([]);
const isGetProduct = ref(true);
const fields = ref([{ type: '', size: '', weight: '', subBox: null }]);
const addField = () => {
    fields.value.push({ type: '', size: '', weight: '', subBox: null });
};

// const addSmaller = ref(false);
const addSubBox = (index) => {
  fields.value[index].subBox = {
    type: '',
    size: '',
    weight: ''
  };
};

const removeSubBox = (index) => {
  fields.value[index].subBox = null;
};


const BoxSize = ref([
    { title: "Select Box Size", value: "" },
    { title: "9x6x3", value: "9x6x3" },
    { title: "12x10x3", value: "12x10x3" },
    { title: "12x12x6", value: "12x12x6" },
    { title: "15x12x10", value: "15x12x10" },
    { title: "16x12x8", value: "16x12x8" },
    { title: "16x16x4", value: "16x16x4" },
    { title: "17x11x8", value: "17x11x8" },
    { title: "17x17x8", value: "17x17x8" },
    { title: "18x14x12", value: "18x14x12" },
    { title: "18x16x14", value: "18x16x14" },
    { title: "20x20x12", value: "20x20x12" },
    { title: "20x16x16", value: "20x16x16" },
    { title: "20x14x6", value: "20x14x6" },
    { title: "20x12x12", value: "20x12x12" },
    { title: "22x18x16", value: "22x18x16" },
    { title: "24x16x12", value: "24x16x12" },
    { title: "24x18x18", value: "24x18x18" },
    { title: "24x24x16", value: "24x24x16" },
    { title: "26x20x8", value: "26x20x8" },
    { title: "26x20x20", value: "26x20x20" },
    { title: "29x24x24", value: "29x24x24" },
    { title: "30x30x16", value: "30x30x16" },
    { title: "28x16x7", value: "28x16x7" },
    { title: "36x20x9", value: "36x20x9" },
    { title: "24x6x6", value: "24x6x6" },
    { title: "36x8x8", value: "36x8x8" },
    { title: "6x6x6", value: "6x6x6" },
    { title: "8x8x8", value: "8x8x8" },
    { title: "10x10x10", value: "10x10x10" },
    { title: "12x12x12", value: "12x12x12" },
    { title: "14x14x14", value: "14x14x14" },
    { title: "16x16x16", value: "16x16x16" },
    { title: "18x18x18", value: "18x18x18" },
    { title: "20x20x20", value: "20x20x20" },
    { title: "22x22x22", value: "22x22x22" },
    { title: "24x24x24", value: "24x24x24" },
    { title: "24x24x24 DW", value: "24x24x24" },
    { title: "26x26x26", value: "26x26x26" },
    { title: "28x28x28", value: "28x28x28" },
    { title: "32x32x32 DW 275", value: "32x32x32" },
    { title: "34x34x34", value: "34x34x34" },
    { title: "36x36x36", value: "36x36x36" },
    { title: "24x6x18 275 lb", value: "24x6x18" },
    { title: "24x18x6", value: "24x18x6" },
    { title: "30x24x6", value: "30x24x6" },
    { title: "30x6x24 275 lb", value: "30x6x24" },
    { title: "36x8x30 275 lb", value: "36x8x30" },
    { title: "36x6x42 275 lb", value: "36x6x42" },
    { title: "40x8x50 275 lb", value: "40x8x50" },
    { title: "54x8x28 275 lb (bicycle)", value: "54x8x28" },
    { title: "48x6x32-72 275 lb (Art Jumbo)", value: "48x6x32" },
    { title: "42x8x60 400 lb Dw", value: "42x8x60" },
    { title: "6x6x48 (Pole)", value: "6x6x48" },

    { title: "10x10x48 (Golf /Umbrella)", value: "10x10x48" },
    { title: "15x15x48 (Golf Bag)", value: "15x15x48" },
    { title: "18x18x28 (Dish Pack)", value: "18x18x28" },
    { title: "20x8x50 (Guitar)", value: "20x8x50" },
    { title: "24x13x31 (suitecase)", value: "24x13x31" },
    { title: "35x22x22 (EH)", value: "35x22x22" },
    { title: "40x18x8 (Laydown)", value: "40x18x8" },
    { title: "54x8x28 275 lb (bicycle)", value: "54x8x28" },

    { title: "9x6x3 (Medium Secruity)", value: "9x6x3" },
    { title: "12x10x3 (Large Security)", value: "12x10x3" },
    { title: "12x12x6 UPS-13", value: "12x12x6" },
    { title: "15x12x10 UPS-21", value: "15x12x10" },
    { title: "16x12x8", value: "16x12x8" },
    { title: "16x16x4 UPS-17", value: "16x16x4" },
    { title: "16x16x8 UPS-31", value: "16x16x8" },
    { title: "17x11x8 UPS-27", value: "17x11x8" },
    { title: "17x17x8 UPS -29", value: "17x17x8" },
    { title: "18x14x12 (1680670 #44)", value: "18x14x12" },
    { title: "20x20x12 UPS-60", value: "20x20x12" },
    { title: "20x12x12 UPS-34", value: "20x12x12" },
    { title: "24x18x18 UPS-46B", value: "24x18x18" },
    { title: "24x24x16 UPS-47B", value: "24x24x16" },
    { title: "17x17x8 Laptop (All-in-one) ", value: "17x17x8" },
    { title: "10x5x3 Cell Phone (All-in-one)", value: "10x5x3" },

]);

const removeField = (index) => {
    if (fields.value.length > 1) fields.value.splice(index, 1);
};


const isSubmit = ref(false);
const productData = ref('');

function parseSize(str) {
  const [l, w, h] = str.split('x').map(Number);
  return { l, w, h, volume: l * w * h };
}

function isSmaller(child, parent) {
  if (!child || !parent) return false;

  const c = parseSize(child);
  const p = parseSize(parent);

  return c.l <= p.l && c.w <= p.w && c.h <= p.h && c.volume < p.volume;
}

const getValidSubBoxOptions = (parentSize) => {
  return BoxSize.value.filter(box => {
    return box.value !== parentSize && isSmaller(box.value, parentSize);
  });
};

const submit = () => {
    errors.value = [];
    fields.value.forEach((field, index) => {
        if (!field.type || !field.size || !field.weight) {
            errors.value.push(`Box ${index + 1}: Type and Size and Weight must be selected.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Type and Size and Weight must be selected.`);
        }
        if(field?.subBox != null && (field?.subBox.type === '' || field?.subBox.size === '')){
            errors.value.push(`Sub Box ${index + 1}: Sub Box Type and Size  must be selected.`);
            store.commit('setErrorNotification', `Sub Box ${index + 1}: Sub Box Type and Size must be selected.`);
        }
        if(getValidSubBoxOptions(field.size).length === 0 && field?.subBox != null){
            errors.value.push(`Sub Box ${index + 1}: Sub Box Size must be selected.`);
            store.commit('setErrorNotification', `Sub Box ${index + 1}: Sub Box Size must be selected.`);
        }
        if (isNaN(field.weight)) {
            errors.value.push(`Box ${index + 1}: Weight must be a number.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Weight must be a number.`);
        }
        if (field.weight && field.weight <= 0) {
            errors.value.push(`Box ${index + 1}: Weight must be greater than zero.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Weight must be greater than zero.`);
        }
    });
    setTimeout(() => {
        store.commit('clearNotifications');
    }, 3000);
    if (errors.value.length > 0) {
        return;
    }


    isSubmit.value = true;
    axios.post("api/addProductBoxes", { id: decodeURIComponent(atob(route.params.id)), boxes: fields.value }).then((response) => {
        console.log('check:',response.data);
        store.commit('setSuccessNotification', "Product Boxes Added Successfully");
        store.commit('setErrorNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 5000);
        isSubmit.value = false;
    }).catch((error) => {
        isSubmit.value = false;
        if (error.response?.data && error.response?.data.error) {
            store.commit('setErrorNotification', error.response.data.error);
            store.commit('setSuccessNotification', null);
        }
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 5000);
        console.error(error);
    });
};


const getSingleProduct = () => {
    axios.post("api/getSingleProduct", { id: decodeURIComponent(atob(route.params.id)) }).then((response) => {
        productData.value = response.data.product;
        isGetProduct.value = false;
        if(response.data.boxes != null && response.data.boxes.length > 0){
            fields.value = response.data.boxes.map(item => ({
                type: item.type,
                size: item.size,
                weight: item.weight,
                subBox: item.subBox ? {type: item.subBox.type, size: item.subBox.size, weight: item.subBox.weight } : null
            }));
        }
    }).catch((error) => {
        isGetProduct.value = false;
        console.error(error);
    });
}


onMounted(() => {
    getSingleProduct();
});
</script>

<template>
    <div class="py-4 container-fluid ctm-mobile-padding">
        <div class="row mt-4">
            <div class="col-lg-12 mb-lg-0 mb-4">
                <div class="card p-3 p-md-5 shadow-lg rounded-xl bg-light-color text-gray-800 position-relative">

                    <div class="ctm-loader" v-if="isGetProduct || isSubmit">
                        <div class="loader" id="loader-5">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <!-- Header -->
                    <div class="d-flex justify-space-between align-items-center mb-2">
                        <h2 class="text-2xl font-bold box-heading">Product Details</h2>
                    </div>

                    <!-- Customer Details -->
                    <div class="row">
                        <div class="col-md-3">
                            <div>
                                <img :src="productData.photo_url" class="productImg" loading="lazy"/>
                            </div>
                            <div>
                                <p class="text-sm text-gray-500 mb-1"><strong>ID: </strong> {{ productData.product_number  }}</p>
                            </div>

                            <div>
                                <p class="text-sm text-gray-500 mb-1"><strong>Value: </strong> ${{productData.value}} USD</p>
                            </div>
                            <div>
                                <p class="text-sm text-gray-500 mb-1"><strong>Description: </strong> {{productData.description}}</p>
                            </div>
                            <div>
                                <!-- <p class="text-sm text-gray-500 mb-1"><strong>Owner: </strong> <a href="#">{{productData.owner_name}}</a></p> -->
                            </div>
                        </div>
                        <div class="col-md-3 ">

                            <div class="mb-4">
                                <p class="mb-1"><strong>Dimensions</strong></p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Length:</strong> {{productData.length}}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Depth:</strong>{{productData.frame_depth}}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Height:</strong>{{productData.frame_height}}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Width:</strong> {{productData.frame_width}}</p>
                            </div>
                            <!-- <div class="mb-4">
                                <p class="mb-1"><strong>Picking Address</strong></p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Street:</strong> {{productData.picking_address}}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>City:</strong> {{productData.picking_city}}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Zipcode:</strong>{{productData.picking_zipcode}}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Country:</strong>{{productData.picking_country}}</p>
                            </div> -->
                        </div>
                        <div class="col-md-3">
                            <div class="mb-4">
                                <p class="mb-1"><strong>Lot Details</strong></p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Lot URL:</strong> <a
                                        :href="productData.lot_url"
                                        target="_blank">Click Here</a></p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Lot Number:</strong> {{ productData.lot_number }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Catalog Name:</strong> {{ productData.catalog_name }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Catalog Reference:</strong>{{ productData.catalog_reference }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Catalog Date:</strong>{{ productData.catalog_date }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Parent Category:</strong>{{ productData.parent_category }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Category:</strong>{{ productData.category }}</p>
                            </div>
                        </div>
                        <!-- <div class="col-md-3">
                            <div class="mb-4">
                                <p class="mb-1"><strong>Buyer and Shipping</strong></p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Buyer Name:</strong> {{ productData.buyer_name }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Shipping Address:</strong>{{ productData.shipping_address }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Shipping City:</strong>{{ productData.shipping_city }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Shipping State:</strong>{{ productData.shipping_state }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Shipping Zipcode:</strong>{{ productData.shipping_zipcode }}</p>
                                <p class="text-sm text-gray-500 mb-1"><strong>Shipping Country:</strong>{{ productData.shipping_country }}</p>
                            </div>
                        </div> -->
                    </div>

                    <!-- Auction Summary -->
                    <!-- <div class="auction-content d-flex justify-content-between align-items-center mb-4">
            <button class="open-btn">Add Boxes</button>
          </div> -->
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!-- Modal -->
                        <div class="card h-100 p-4 rounded-xl mt-4 bg-dark-yellow bg-gray-50">
                            <h3 class="text-xl font-semibold text-[#7b5540] mb-4 box-heading">Add Boxes</h3>
                            <!-- Box Fields -->
                            <div v-for="(field, index) in fields" :key="index" class="border border-white p-4 rounded mb-3">
                                <!-- Box Type -->
                                <div class="row w-100">
                                    <div class="col-md-3">
                                        <label for="weight">Packaging Type</label>
                                        <select v-model="field.type" class="input">
                                            <option disabled value="">Select Packaging Type</option>
                                            <option>Standard</option>
                                            <option>Fragile</option>
                                            <option>Custom</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="weight">Box Size</label>
                                        <select v-model="field.size" class="input">
                                            <option v-for="(boxes, index) in BoxSize" :key="index" :value="boxes.value"
                                                :disabled="boxes.value === ''">
                                                {{ boxes.title }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3"><label for="weight">Enter weight (LBS):</label>
                                        <input type="text" id="weight" min="0" name="weight" v-model="field.weight"
                                            placeholder="e.g., 65"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')" class="input" />
                                    </div>
                                    <div class="col-md-3 d-flex align-items-end">
                                        <div class="d-flex align-items-end gap-2">
                                            <!-- Individual Remove -->
                                            <button v-if="fields.length > 1" @click="removeField(index)"
                                                class="remove-input ml-2">X</button>

                                            <!-- Add Sub-Box Button -->
                                            <div v-if="!field.subBox" class="">
                                                <button @click="addSubBox(index)" class="btn btn-secondary mb-0">Add Sub-Box</button>
                                            </div>
    
                                            
                                        </div>
                                    </div>
                                </div>

                                <div v-if="field.subBox" class="row mt-2 mb-3 p-4 border px-2 bg-white mx-1">
                                    <div class="col-md-5">
                                        <label for="weight">Packaging Type</label>
                                        <select v-model="field.subBox.type" class="input">
                                            <option disabled value="">Select Packaging Type</option>
                                            <option>Standard</option>
                                            <option>Fragile</option>
                                            <option>Custom</option>
                                        </select>
                                    </div>
                                    <div class="col-md-5">
                                        <label>Sub Box Size</label>
                                        <select v-model="field.subBox.size" class="input" :disabled="!field.size">
                                            <option v-for="(box, i) in getValidSubBoxOptions(field.size)" :key="i" :value="box.value" >{{ box.title }}</option>
                                        </select>
                                    </div>
                                    <div class="col d-flex align-items-end">
                                        <button @click="removeSubBox(index)" class="remove-input mt-2">X</button>
                                    </div>
                                </div>
                            </div>
                            <div class="plus-group mt-4">
                                <button @click="addField" class="add-btn">Add More</button>
                            </div>

                            <div class="row">
                                <!-- <div class="col-6">
                                    <div class="chargeDesign">
                                        <h5>PickUp Charges</h5>
                                        <input  min="0" step="0.01" type="number" placeholder="Enter Pickup charge" v-model="pickupCharge" @input="validatePickupCharge">
                                    </div>
                                </div> -->
                                <div class="col-12">
                                    <!-- Actions -->
                                    <div class="modal-actions">
                                        <!-- <button class="" @click="submit">Save</button> -->
                                        <button @click="submit" :disabled="isSubmit">Save</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>


<style scoped>
.cardOuter .card.cardBackDesign {
    background: #ffffffba !important;
    margin-bottom: 20px !important;
}

.card.cardBackDesign label {
    font-size: 14px !important;
}

.card {
    margin: auto;
    box-shadow: 0 8px 26px -4px rgba(0, 0, 0, 0.08);
    background-color: #F2E5D7 !important;
    position: relative;
}

table {
    border-collapse: separate;
    border-radius: 10px;
    background-color: #fff;
}

.field-group {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.input {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.input:focus,
input:focus {
    outline: none;
}

.open-btn,
.modal-actions button {
    background: #a35c2e !important;
    border: none;
    color: #fff;
    border-radius: 5px;
    padding: 8px 30px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
}

.modal-actions {
    display: flex;
    margin-top: 20px;
    gap: 10px;
    justify-content: end;
}

.plus-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.add-btn,
.remove-input {
    background: #a35c2e !important;
    color: #fff;
    padding: 8px 15px;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 600;
}

th {
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

.auction-content h2,
.box-heading {
    font-size: 22px;
    color: #5D4037;
}

td {
    font-size: 15px;
}

.send-mail button {
    background: #a35c2e !important;
    border: none;
    color: #fff;
    border-radius: 5px;
    padding: 8px 30px;
    cursor: pointer;
    font-weight: 600;
    width: 100%;
    margin-top: 15px;
}

.bg-yellow {
    background-color: #f4e48f;
}

.bg-dark-yellow {
    background-color: #fff3ce;
}

.bg-light-color {
    background-color: #f7f7f9;
}

label,
.form-label {
    font-size: 16px;
    color: #000;
}

input[type="radio" i] {
    width: 25px;
    height: 15px;
}

.add-btn {
    position: absolute;
    top: 23px;
}

.input,
input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
}


/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.modal-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    margin-top: 10px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    border-top: none !important;
}

.close-button {
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
}

.chargeDesign h5 {
    font-size: 13px;
}



.chargeDesign input {
    padding: 5px 10px;
    width: 138px;
    border-radius: 5px;
}

img.productImg {
    width: 120px;
    height: 120px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    object-fit: cover;
    border-radius: 4px;
}
</style>
